module.exports = __webpack_public_path__ + "img/domicile.534617d9.jpg";